export default "__VITE_ASSET__BDhJMCvX__"